export default __webpack_public_path__ + "static/media/Elisha 9781408362402.a1c6e9c8.jpg";